export default "__VITE_ASSET__Co4Ntn5h__"